<div class="editor-page">
  <div class="container-xxl editor">
    <header class="editor-head">
      <div class="editor-banner">
        <img src="assets/img/contactBar.png" alt="">
        <h1>Richiedi accesso</h1>
      </div>
      <p class="editor-lead">Richiedi accesso per ottenere la visualizzazione completa dell'archivio opere d'arte.</p>
      <p class="editor-note">I campi con <sup>*</sup> sono obbligatori.</p>
    </header>

    <form class="editor-form" [formGroup]="signupForm">
      <section class="editor-panel">
        <h2>Dati personali</h2>
        <div class="field-grid field-grid-2">
          <div class="field-block">
            <label for="name">Nome<sup>*</sup></label>
            <input id="name" class="field" type="text" formControlName="name" autocomplete="given-name"
              (input)="checkSignupForm()"
              [class.is-invalid]="signupForm.get('name')?.invalid && (signupForm.get('name')?.touched || signupForm.get('name')?.dirty)">
          </div>
          <div class="field-block">
            <label for="surname">Cognome<sup>*</sup></label>
            <input id="surname" class="field" type="text" formControlName="surname" autocomplete="family-name"
              (input)="checkSignupForm()"
              [class.is-invalid]="signupForm.get('surname')?.invalid && (signupForm.get('surname')?.touched || signupForm.get('surname')?.dirty)">
          </div>
        </div>
        <div class="field-block email-block">
          <label for="email">Email<sup>*</sup></label>
          <input id="email" class="field" type="email" formControlName="email" autocomplete="email"
            (input)="checkEmail()"
            [class.is-invalid]="signupForm.get('email')?.invalid && (signupForm.get('email')?.touched || signupForm.get('email')?.dirty)">
        </div>
      </section>

      <section class="editor-panel">
        <h2>Password</h2>
        <div class="field-grid field-grid-2">
          <div class="field-block">
            <label for="password">Nuova password<sup>*</sup></label>
            <div class="password-field">
              <input id="password" class="field" [type]="type1" formControlName="password" autocomplete="new-password"
                (input)="checkPassword()"
                [class.is-invalid]="signupForm.get('password')?.invalid && (signupForm.get('password')?.dirty || signupForm.get('password')?.touched)">
              <button class="password-toggle" type="button" (click)="seePassword('password1')"
                [attr.aria-label]="toggled1 ? 'Mostra password' : 'Nascondi password'">
                <i class="bi" [class.bi-eye]="toggled1" [class.bi-eye-slash]="!toggled1" aria-hidden="true"></i>
              </button>
            </div>
            @if (errorMessage && !validPassword) {
              <p class="field-error">La password deve essere lunga almeno 8 caratteri, contenere una maiuscola e un simbolo speciale.</p>
            }
          </div>

          <div class="field-block">
            <label for="password_confirmation">Ripeti password<sup>*</sup></label>
            <div class="password-field">
              <input id="password_confirmation" class="field" [type]="type2" formControlName="password_confirmation"
                autocomplete="new-password" (input)="checkPassword()"
                [class.is-invalid]="signupForm.get('password_confirmation')?.invalid && (signupForm.get('password_confirmation')?.dirty || signupForm.get('password_confirmation')?.touched)">
              <button class="password-toggle" type="button" (click)="seePassword('password2')"
                [attr.aria-label]="toggled2 ? 'Mostra conferma password' : 'Nascondi conferma password'">
                <i class="bi" [class.bi-eye]="toggled2" [class.bi-eye-slash]="!toggled2" aria-hidden="true"></i>
              </button>
            </div>
            @if (errorMessage && !equalPassword) {
              <p class="field-error">Le due password sono differenti.</p>
            }
          </div>
        </div>
      </section>

      <section class="editor-panel">
        <h2>Motivo della richiesta</h2>
        <div class="field-block">
          <label for="description">Informazioni aggiuntive<sup>*</sup></label>
          <textarea id="description" class="field field-textarea" formControlName="description" rows="3"
            placeholder="Inserisci il motivo della richiesta"></textarea>
        </div>
      </section>

      <div class="editor-actions">
        @if (signupForm.invalid) {
          <p class="editor-hint">Completa correttamente tutti i campi.</p>
        }
        <button class="editor-save" type="button" [disabled]="!signupForm.valid" (click)="onSubmit()">
          Richiedi
        </button>
      </div>
    </form>
  </div>
</div>
